import { Subject } from 'rxjs/Subject';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ClientsService {
  private clientsSubject;

  constructor() {
    this.clientsSubject = new Subject();
  }

  getClientsSubject(): Observable<Object> {
    return this.clientsSubject.asObservable();
  }

  clientChanged() {
    this.clientsSubject.next('client changed');
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/services/clients/clients.service.ts